var app = {
	header: {
		build: "Build",
		closeButton: "Chiudi",
		copyrightLabel: "Copyright",
		helpLabel: "Aiuto",
		legalNoticeLabel: "Avviso legale",
		logoutButton: "Esci",
		menuLabel: "Menu",
		module: "Modulo",
		myData: "I miei dati",
		noUserDataLabel: "Nessun dato utente disponibile",
		notificationsLabel: "Notifiche",
		privacyPolicyLabel: "Informativa sulla privacy",
		serviceAppLabel: "Service-App",
		settingsLabel: "Impostazioni",
		shopLabel: "Shop",
		smartFactorySuiteLabel: "Smart-Factory Suite",
		softwareInformation: "Informazioni sul software",
		toMytrumpf: "A MyTRUMPF",
		toTrumpfCom: "A trumpf.com",
		userLabel: "Profilo",
		userProfileLinkText: "Profilo utente",
		version: "Versione"
	}
};
var contentLoadingError = "Impossibile caricare il contenuto";
var dashboard = {
	cancel: {
		button: "Annulla"
	},
	edit: {
		button: "Modifica"
	},
	reset: {
		button: "Ripristina"
	},
	save: {
		button: "Salva"
	},
	share: {
		button: "Condividi"
	}
};
var fileUpload = {
	invalidFileType: "Il file è del tipo sbagliato",
	maxFileSize: "Il file è più grande della dimensione consentita (max. {{maxSizeInMb}} MB)",
	maxFilesReached: "Numero massimo di file raggiunto"
};
var filter = {
	clear: "Rimuovi i filtri",
	clearAll: "Rimuovi tutti i filtri"
};
var general = {
	nextButton: "Avanti",
	prevButton: "Indietro",
	resetButton: "Ripristina"
};
var locationMap = {
	locationLink: {
		label: "Vai al luogo"
	}
};
var machineDiscontinuation = {
	linkText: "Ulteriori informazioni"
};
var notifications = {
	button: {
		loadMore: "Carica di più"
	},
	date: {
		lastMonth: "Lo scorso mese",
		lastWeek: "La settimana scorsa",
		older: "Più vecchio",
		thisMonth: "Questo mese",
		thisWeek: "Questa settimana",
		today: "Oggi",
		yesterday: "Ieri"
	},
	error: {
		general: "Al momento non è possibile visualizzare notifiche. Riprova più tardi.",
		unauthorized: "Accedi per vedere le notifiche"
	},
	info: {
		activateSettings: "Per ricevere le notifiche, abilitale nelle impostazioni",
		noNotification: "Al momento non ci sono messaggi per te."
	},
	title: "Notifiche"
};
var results = {
	counter: {
		label: "risultati"
	}
};
var scrollToTop = {
	label: "Torna in alto"
};
var slider = {
	nextButton: {
		label: "Prossima diapositiva"
	},
	paginationBullet: {
		label: "Diapositiva"
	},
	prevButton: {
		label: "Diapositiva precedente"
	}
};
var sorting = {
	ascending: "Crescente",
	descending: "Decrescente"
};
var userAccount = {
	address: {
		label: "Indirizzo postale"
	},
	email: {
		label: "E-mail"
	},
	language: {
		label: "Lingua",
		locale: "Locale",
		select: "Seleziona la lingua",
		settings: "Impostazioni della lingua"
	},
	loggedOut: {
		message: "Non sei loggato"
	},
	login: {
		button: "Accedi"
	},
	name: {
		label: "Nome"
	},
	phone: {
		label: "Telefono"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Filtra macchine",
			label: "Macchine",
			option: {
				all: "Tutte le macchine"
			},
			select: "Seleziona macchina"
		},
		period: {
			label: "Periodo",
			option: {
				currentMonth: "Questo mese",
				currentWeek: "Questa settimana",
				lastMonth: "Il mese scorso",
				lastWeek: "La scorsa settimana",
				today: "Oggi",
				yesterday: "Ieri"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "I miei widget"
	},
	noDescriptionAvailable: "Nessuna descrizione disponibile.",
	widget: {
		SampleMyMachines: {
			title: "Le mie macchine"
		},
		SampleMyServiceCalls: {
			title: "Chiamate di servizio"
		},
		SampleMyTrackingList: {
			title: "Elenco di monitoraggio"
		},
		SampleMyUserAccount: {
			title: "Il mio profilo"
		},
		SampleOperationalStatesChart: {
			title: "Stati operativi"
		},
		SampleWidgetFilter: {
			title: "Impostazioni filtro"
		},
		SampleWorkloadBalanceChart: {
			title: "Bilanciamento del carico di lavoro"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	fileUpload: fileUpload,
	filter: filter,
	general: general,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, fileUpload, filter, general, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };

//# sourceMappingURL=translation8-b11f6725.js.map